export enum NavigationTypes {
    "LOGIN" = "LOGIN",
    "PUBLIC_HOME" = "PUBLIC_HOME",
    "REGISTRATION" = "REGISTRATION",
    "HOME" = "HOME",
    "PRIVATE_HOME" = "PRIVATE_HOME",
    "FORGOT_PASSWORD" = "FORGOT_PASSWORD",
    "EVENTS" = "EVENTS",
    "PUBLIC_HOW_TO" = "PUBLIC_HOW_TO",
    "HOW_TO" = "HOW_TO",
    "FAQ" = "FAQ",
    "PUBLIC_FAQ" = "PUBLIC_FAQ",
    "CONTACTS" = "CONTACTS",
    "PROFILE" = "PROFILE",
    "FRIENDS" = "FRIENDS",
    "HISTORY_REWARDS" = "HISTORY_REWARDS",
    "HISTORY_REWARDS_CONTEST" = "HISTORY_REWARDS_CONTEST",
    "HISTORY_REWARDS_CATALOG" = "HISTORY_REWARDS_CATALOG", // deprecated
    "HISTORY_REWARDS_CATALOG_LOYALTY_COLLECTION" = "HISTORY_REWARDS_CATALOG_LOYALTY_COLLECTION",
    "HISTORY_REWARDS_CATALOG_DIGITAL_WALLET" = "HISTORY_REWARDS_CATALOG_DIGITAL_WALLET",
    "HISTORY_REWARDS_DETAILS" = "HISTORY_REWARDS_DETAILS",
    "HISTORY_REWARDS_CONTEST_DETAILS" = "HISTORY_REWARDS_CONTEST_DETAILS",
    "HISTORY_REWARDS_CATALOG_DETAILS" = "HISTORY_REWARDS_CATALOG_DETAILS",
    "HISTORY_REWARDS_CATALOG_LOYALTY_COLLECTION_DETAILS" = "HISTORY_REWARDS_CATALOG_LOYALTY_COLLECTION_DETAILS",
    "HISTORY_REWARDS_CATALOG_DIGITAL_WALLET_DETAILS" = "HISTORY_REWARDS_CATALOG_DIGITAL_WALLET_DETAILS",
    "HISTORY_CONTESTS" = "HISTORY_CONTESTS",
    "HISTORY_CONTESTS_DETAILS" = "HISTORY_CONTESTS_DETAILS",
    "HISTORY_POINTS" = "HISTORY_POINTS",
    "LOGOUT" = "LOGOUT",
    "CONTESTS" = "CONTESTS",
    "CONTEST_DETAILS" = "CONTEST_DETAILS",
    "GO_TO_REDEMPTION" = "GO_TO_REDEMPTION",
    "EVENT_DETAILS" = "EVENT_DETAILS",
    "REDEEM" = "REDEEM",

    "CATALOG" = "CATALOG", // deprecated
    "CATALOG_DIGITAL_WALLET" = "CATALOG_DIGITAL_WALLET",
    "PUBLIC_CATALOG_DIGITAL_WALLET" = "PUBLIC_CATALOG_DIGITAL_WALLET",
    "CATALOG_LOYALTY_COLLECTION" = "CATALOG_LOYALTY_COLLECTION",
    "PUBLIC_CATALOG_LOYALTY_COLLECTION" = "PUBLIC_CATALOG_LOYALTY_COLLECTION",


    "PRODUCT_DETAILS" = "PRODUCT_DETAILS", // deprecated
    "CATALOG_DIGITAL_WALLET_DETAILS" = "CATALOG_DIGITAL_WALLET_DETAILS",
    "PUBLIC_CATALOG_DIGITAL_WALLET_DETAILS" = "PUBLIC_CATALOG_DIGITAL_WALLET_DETAILS",
    "CATALOG_LOYALTY_COLLECTION_DETAILS" = "CATALOG_LOYALTY_COLLECTION_DETAILS",
    "PUBLIC_CATALOG_LOYALTY_COLLECTION_DETAILS" = "PUBLIC_CATALOG_LOYALTY_COLLECTION_DETAILS",

    "EVENT_FORM" = "EVENT_FORM",
    "CONTEST_EVENT_FORM" = "CONTEST_EVENT_FORM",
    "NO_AUTH" = "NO_AUTH",
    "NOT_FOUND" = "NOT_FOUND",
    "MAINTENANCE" = "MAINTENANCE",
    "SSO_FINALIZE" = "SSO_FINALIZE",
    "REGISTRATION_FINALIZE" = "REGISTRATION_FINALIZE",
    "SERVER_ERROR" = "SERVER_ERROR",
    "CHECKOUT" = "CHECKOUT",
    "CART" = "CART",

    //CUSTOM
    "PUBLIC_AZIMUT_FONDI" = "PUBLIC_AZIMUT_FONDI",
    "PUBLIC_AZIMUT_ABOUT" = "PUBLIC_AZIMUT_ABOUT",
    "AZIMUT_FONDI" = "AZIMUT_FONDI",
    "AZIMUT_ABOUT" = "AZIMUT_ABOUT",

    //Finalization Extra
    "FINALIZATION_EXTRA" = "FINALIZATION_EXTRA",

    //VAS
    "VAS" = "VAS",
    "PUBLIC_VAS" = "PUBLIC_VAS",
    "DATA_ENTRY_CHECKOUT" = "DATA_ENTRY_CHECKOUT",
    "THANKYOU_PAGE" = "THANKYOU_PAGE",
    "SUBSCRIPTION_DETAILS" = "SUBSCRIPTION_DETAILS",

    /**
     * PDA
     * - History page: profile/pda/history
     * - History detail page: /profile/pda/history/:logicId
     */
    "HISTORY_PDA" = "HISTORY_PDA",
    "HISTORY_PDA_DETAILS" = "HISTORY_PDA_DETAILS",
}

export type NavigationType = `${NavigationTypes}` | string